module.exports = __webpack_public_path__ + "static/img/zt5888338.faab9f07.png";